// CAPABILITY: Persistent anonymous chat identity (browser)
// Reuses the analytics viewer UUID so chat identity == analytics identity, and
// caches the viewer's chosen display name in localStorage so it persists across
// reloads on this device. No login.

import { createOrGetAnalyticsViewerId } from "../../analytics/utils/sessionId";
import { DISPLAY_NAME_MAX_CHARS, DISPLAY_NAME_MIN_CHARS } from "../chatConfig";

const DISPLAY_NAME_STORAGE_KEY = "vdopage_chat_display_name_v1";
const NAME_CHARSET = /^[\p{L}\p{N} ._-]+$/u;

export function getChatViewerId() {
  return createOrGetAnalyticsViewerId();
}

export function getCachedDisplayName() {
  try {
    return window.localStorage.getItem(DISPLAY_NAME_STORAGE_KEY) || "";
  } catch (_error) {
    return "";
  }
}

export function setCachedDisplayName(name) {
  try {
    if (name) window.localStorage.setItem(DISPLAY_NAME_STORAGE_KEY, name);
  } catch (_error) {
    /* ignore quota/availability errors */
  }
}

// Deterministic, client-side name validation (matched server-side). Returns
// { ok, value, reason }. Does not perform LLM checks (server does that).
export function validateDisplayNameClient(rawName) {
  const name = String(rawName || "").trim().replace(/\s{2,}/g, " ");
  if (name.length < DISPLAY_NAME_MIN_CHARS) {
    return { ok: false, value: name, reason: `Name must be at least ${DISPLAY_NAME_MIN_CHARS} characters.` };
  }
  if (name.length > DISPLAY_NAME_MAX_CHARS) {
    return { ok: false, value: name, reason: `Name must be ${DISPLAY_NAME_MAX_CHARS} characters or fewer.` };
  }
  if (!NAME_CHARSET.test(name)) {
    return { ok: false, value: name, reason: "Use letters, numbers, spaces, . _ - only." };
  }
  return { ok: true, value: name, reason: "" };
}

export { DISPLAY_NAME_STORAGE_KEY };
